/* global axios */
import ApiClient from './ApiClient';

class LaisWhatsappGovernanceAPI extends ApiClient {
  constructor() {
    super('lais/whatsapp', { accountScoped: true });
  }

  getProfile() {
    return axios.get(`${this.url}/profile`);
  }

  updateProfile(payload) {
    return axios.patch(`${this.url}/profile`, payload);
  }

  uploadPhoto(formData) {
    return axios.post(`${this.url}/profile/photo`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }

  requestDisplayName(payload) {
    return axios.post(`${this.url}/display_name_requests`, payload);
  }

  getOnboarding() {
    return axios.get(`${this.url}/onboarding`);
  }

  updateOnboarding(payload) {
    return axios.patch(`${this.url}/onboarding`, payload);
  }
}

export default new LaisWhatsappGovernanceAPI();
